import {
  div,
  h1,
  span,
  button,
  fnstate,
  table,
  thead,
  tbody,
  tr,
  th,
  td
} from '@srfnstack/fntags'
import { createFetcher } from '../utils/api.js'

export const Tags = () => {
  const tags = fnstate([], t => t.id)
  const loading = fnstate(true)

  const fetchTags = createFetcher(() => fetch('/api/system/tags'), tags, loading)

  const deleteTag = async (id) => {
    if (await window.confirm('Delete this tag from the library?')) {
      const res = await fetch(`/api/system/tags/${id}`, { method: 'DELETE' })
      if (res.ok) fetchTags()
    }
  }

  fetchTags()

  return div({ class: 'p-6 space-y-6' },
    div({ class: 'flex justify-between items-center' },
      h1({ class: 'text-3xl font-bold' }, 'Tag Library'),
      button({ class: 'btn btn-outline btn-sm', onclick: fetchTags }, 'Refresh')
    ),
    div({ class: 'card bg-base-100 border border-base-300 shadow-sm overflow-hidden' },
      div({ class: 'overflow-x-auto' },
        loading.bindAs(l => l
          ? div({ class: 'flex justify-center p-12' }, span({ class: 'loading loading-spinner loading-lg' }))
          : tags.bindAs(list => list.length === 0
            ? div({ class: 'text-center p-12 opacity-50' }, 'No tags in the library yet.')
            : div(
              table({ class: 'table w-full' },
                thead(
                  tr(
                    th('Tag'),
                    th('Usage'),
                    th('Performance'),
                    th('Last Used'),
                    th('Actions')
                  )
                ),
                tags.bindChildren(tbody(),
                  itemState => {
                    const t = itemState()
                    return tr(
                      td({ class: 'font-bold' }, t.tag),
                      td(span({ class: 'badge badge-ghost font-mono' }, t.usage_count)),
                      td(span({ class: 'text-success font-bold' }, `${t.performance_score}%`)),
                      td(t.last_used ? new Date(t.last_used).toLocaleDateString() : 'Never'),
                      td(
                        button({ class: 'btn btn-ghost btn-xs text-error', onclick: () => deleteTag(t.id) }, 'Delete')
                      )
                    )
                  }
                )
              )
            )
          )
        )
      )
    )
  )
}
